import { useParams } from 'react-router-dom';
import { Col, Form, Row } from 'antd';

import { offerStore } from 'containers/Offers/Offer/store';
import { Loader, MilesForm } from 'components';

import { useGetRequest } from 'hooks';

import { OfferItemDetails } from 'codegen';

import { Identities } from './Identities';
import { fields, handleSuccessGetOfferItemDetails } from './offerItemsHelpers';

const { useForm } = Form;

export const OfferItems = () => {
  const selectItems = offerStore((state) => state.selectItems);
  const selectedItemId = offerStore((state) => state.selectedItemId);

  const [form] = useForm();
  const { offerId } = useParams();

  const { data, loading } = useGetRequest<OfferItemDetails>({
    url: `/offers/details/${offerId}/items/${selectedItemId}`,
    options: {
      ready: !!selectedItemId,
      refreshDeps: [selectedItemId],
      onSuccess: handleSuccessGetOfferItemDetails,
    },
  });

  const initialValues = {
    selectedItemId,
    isActive: data?.isActive,
    priceRequired: data?.priceRequired,
    quantityRequired: data?.quantityRequired,
  };

  return (
    <Loader isLoading={loading}>
      <Row className='mb-10'>
        <Col xs={10} xxl={8}>
          <MilesForm
            disabled
            form={form}
            name='offerItems'
            fields={fields(selectItems)}
            initialValues={initialValues}
          />
        </Col>
      </Row>

      <Identities />
    </Loader>
  );
};
